import React from 'react';
import { FadeIn } from './FadeIn';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    initials: 'MR',
    quote: 'Organicé mi forma de atender en una tarde. Ahora entro a consulta con un camino claro y salgo con el plan definido sin trabarme.',
    name: 'Martina R.',
    location: 'Buenos Aires',
    role: 'Nutricionista Clínica'
  }, {
    initials: 'JC',
    quote: "El Tomo 4 es oro. Me da un protocolo claro para cuando el paciente no avanza y me evita 'probar cosas' al azar.",
    name: 'Juan C.',
    location: 'Rosario',
    role: 'Consultorio Particular'
  }, {
    initials: 'SV',
    quote: 'Antes repetía siempre lo mismo. Ahora adapto en minutos según el caso y el paciente entiende mejor y cumple más.',
    name: 'Sofía V.',
    location: 'Córdoba',
    role: 'Nutricionista (clínica/deportiva)'
  }];
  return <section className="pt-8 pb-12 px-4 max-w-6xl mx-auto" data-id="element-270">
      <FadeIn data-id="element-271">
        <h2 className="text-center font-display text-3xl md:text-4xl font-bold text-mint mb-8" data-id="element-272">
          Lo que dicen los nutris que ya lo usan
        </h2>
      </FadeIn>

      <div className="grid md:grid-cols-3 gap-6" data-id="element-273">
        {testimonials.map((t, idx) => <FadeIn key={idx} delay={idx * 0.1} className="bg-surface p-6 rounded-2xl shadow-sm border border-mint/10 relative" data-id="element-274">
            <div className="absolute -top-6 left-8 bg-mint text-black w-12 h-12 rounded-full flex items-center justify-center font-bold text-lg shadow-md" data-id="element-275">
              {t.initials}
            </div>
            <div className="flex gap-1 mb-4 mt-2" data-id="element-276">
              {[...Array(5)].map((_, i) => <Star key={i} size={16} className="fill-mint text-mint" data-id="element-277" />)}
            </div>
            <p className="text-white/80 italic mb-4 leading-relaxed" data-id="element-278">
              "{t.quote}"
            </p>
            <div className="border-t border-mint/10 pt-4" data-id="element-279">
              <p className="font-bold text-mint" data-id="element-280">{t.name}</p>
              <p className="text-sm text-white/50" data-id="element-281">
                {t.location} | {t.role}
              </p>
            </div>
          </FadeIn>)}
      </div>
    </section>;
}